import type { MockTimeLimit, Style, Pool, Gender } from './types';

const STYLE_FACTOR: Record<Style, number> = { SL: 1.0, DO: 1.12, RA: 1.24, FA: 1.04, MX: 1.15 };

// Tempo base SL 100m per categoria maschile (ms).
const CATEGORY_BASE_SL100_M: Record<string, number> = {
    R: 60_000,
    J: 56_500,
    C: 54_000,
    S: 52_500,
    A: 52_000
};

const GENDER_FACTOR: Record<Gender, number> = { M: 1.0, F: 1.095 };
const POOL_FACTOR: Record<Pool, number> = { '25': 0.985, '50': 1.0 };

function fmtMs(ms: number): string {
    const m = Math.floor(ms / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    const cs = Math.floor((ms % 1000) / 10);
    return m > 0
        ? `${m}:${String(s).padStart(2, '0')}.${String(cs).padStart(2, '0')}`
        : `${s}.${String(cs).padStart(2, '0')}`;
}

function genLimit(
    distance: number,
    style: Style,
    pool: Pool,
    gender: Gender,
    category: string,
    scope: MockTimeLimit['scope'],
    adjust = 1.0
): MockTimeLimit {
    const base = CATEGORY_BASE_SL100_M[category] ?? 56_000;
    const ms = base * STYLE_FACTOR[style] * GENDER_FACTOR[gender] * POOL_FACTOR[pool] * (distance / 100) * adjust;
    return {
        id: `tl-${category}-${scope}-${distance}${style}-${pool}-${gender}`,
        distance,
        style,
        pool,
        gender,
        category,
        scope,
        year: 2026,
        limitTime: fmtMs(Math.round(ms))
    };
}

const distances = [50, 100, 200];
const styles: Style[] = ['SL', 'DO', 'RA', 'FA'];
const genders: Gender[] = ['M', 'F'];
const pools: Pool[] = ['25', '50'];
const categories = ['R', 'J', 'C', 'S', 'A'];

const limits: MockTimeLimit[] = [];

categories.forEach(cat => {
    genders.forEach(g => {
        pools.forEach(p => {
            styles.forEach(s => {
                distances.forEach(d => {
                    // Criteria (nazionali categoria)
                    limits.push(genLimit(d, s, p, g, cat, 'Criteria', 0.95));
                    // UnipolSai
                    limits.push(genLimit(d, s, p, g, cat, 'UnipolSai', 0.99));
                    // Regionale
                    limits.push(genLimit(d, s, p, g, cat, 'Regionale', 1.04));
                });
            });
            // 200 MX per categoria
            pools.forEach(() => {}); // no-op (già nel outer)
            limits.push(genLimit(200, 'MX', p, g, cat, 'Criteria', 0.95));
            limits.push(genLimit(200, 'MX', p, g, cat, 'UnipolSai', 0.99));
            limits.push(genLimit(200, 'MX', p, g, cat, 'Regionale', 1.04));
        });
    });
});

export const mockTimeLimits: MockTimeLimit[] = limits;
